<template>
  <v-container fluid class="pa-4">
    <v-row>
      <!-- Panel izquierdo: Formulario de búsqueda -->
      <v-col cols="12" md="3">
        <v-card>
          <v-card-title class="text-h6" style="background-color: #def2ff;" >
            Búsqueda Avanzada
          </v-card-title>

          <v-card-text class="pt-4">
            <!-- Selector de Plantilla -->
            <v-select
              v-model="plantillaSeleccionada"
              :items="plantillas"
              item-title="plantilla"
              item-value="codigo"
              label="Plantilla:"
              variant="outlined"
              density="comfortable"
              class="mb-4"
              @update:model-value="cargarCamposPlantilla"
            ></v-select>

            <!-- ✅ Campos dinámicos según estructura CON LÓGICA MEJORADA -->
            <div v-for="campo in camposBusqueda" :key="campo.nombre">
              
              <!-- ✅ Campo SELECTOR (si tiene valores predefinidos) -->
              <v-select
                v-if="campo.valores"
                v-model="valoresBusqueda[campo.nombre]"
                
                :items="getOpcionesCombo(campo.valores)"
                :label="campo.nombre"
                variant="outlined"
                density="comfortable"
                clearable
                class="mb-4"
              ></v-select>

              <!-- ✅ Campo FECHA (si es tipo date/datetime) -->
              <v-text-field
                v-else-if="esCampoFecha(campo.tipo)"
                v-model="valoresBusqueda[campo.nombre]"
                
                :label="campo.nombre"
                type="date"
                variant="outlined"
                density="comfortable"
                clearable
                class="mb-4"
              ></v-text-field>

              <!-- ✅ Campo TEXTO (por defecto) -->
              <v-text-field
                v-else
                v-model="valoresBusqueda[campo.nombre]"
                
                :label="campo.nombre"
                variant="outlined"
                density="comfortable"
                clearable
                class="mb-4"
              ></v-text-field>
            </div>

            <v-divider class="my-4"></v-divider>

           
            <!-- Tabs: Texto, Anotaciones, Atributos -->
            <v-tabs v-model="tabBusqueda" density="compact" class="mb-4">
              <v-tab value="texto">Texto</v-tab>
              <v-tab value="anotaciones">Anotaciones</v-tab>
              <v-tab value="atributos">Archivos</v-tab>
            </v-tabs>

            <v-window v-model="tabBusqueda">

              <v-window-item value="texto">
                <v-radio-group v-model="textoRadio" >
                 <v-radio label="Exacta" value="1"/>    
                 <v-radio label="Aproximada" value="2"/>
                </v-radio-group> 

                <v-text-field
                  v-model="textoBuscar"
                  label="Texto a buscar"
                  
                  variant="outlined"
                  density="comfortable"
                  class="mb-4"
                ></v-text-field>
              
                   <!-- ✅ CAMPOS ADICIONALES PARA BÚSQUEDA APROXIMADA EN TEXTO -->
                <template v-if="textoRadio === '2'">
                  <!-- Selector de operador Y/O -->
                  <v-select
                    v-model="textoOperador"
                    :items="opcionesOperador"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="compact"
                    class="mb-3"
                    style="max-width: 100px;"
                  ></v-select>

                  <!-- Segundo término de búsqueda -->
                  <v-text-field
                    v-model="textoBuscar2"
                    
                    label="Texto a buscar"
                    variant="outlined"
                    density="comfortable"
                    class="mb-3"
                  ></v-text-field>

                  <!-- Checkbox para excluir palabra -->
                  <v-checkbox
                    v-model="excluirTextoActivo"
                    label="Excluir palabra de la búsqueda"
                    density="compact"
                    hide-details
                    class="mb-2"
                  ></v-checkbox>

                  <!-- Campo de texto a excluir (solo si checkbox activo) -->
                  <v-text-field
                    v-if="excluirTextoActivo"
                    v-model="textoExcluir"
                    label="Texto a excluir"
                    variant="outlined"
                    density="comfortable"
                    class="mb-3"
                  ></v-text-field>
                </template>

              </v-window-item>


              <v-window-item value="anotaciones">

               <v-radio-group v-model="anotacionesRadio">
                 <v-radio label="Exacta" value="1" />
                 <v-radio label="Aproximada" value="2" />
               </v-radio-group>
             
                <v-text-field
                  v-model="anotacionesBuscar"
                  
                  label="Buscar en anotaciones"
                  variant="outlined"
                  density="comfortable"
                  class="mb-4"
                ></v-text-field>

                   <!-- ✅ CAMPOS ADICIONALES PARA BÚSQUEDA APROXIMADA EN ANOTACIONES -->
                <template v-if="anotacionesRadio === '2'">
                  <!-- Selector de operador Y/O -->
                  <v-select
                    v-model="anotacionesOperador"
                    :items="opcionesOperador"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="compact"
                    class="mb-3"
                    style="max-width: 100px;"
                  ></v-select>

                  <!-- Segundo término de búsqueda en anotaciones -->
                  <v-text-field
                    v-model="anotacionesBuscar2"
                    label="Buscar en anotaciones"
                    variant="outlined"
                    density="comfortable"
                    class="mb-3"
                  ></v-text-field>
                </template>

              </v-window-item>

              <v-window-item value="atributos">

              <!-- Fecha de modificacion -->

               <v-text-field 
                 v-model="fechaAtributos"
                  
                 label="Fecha de modificación"
                 type="date"
                 variant="outlined"
                 density="comfortable"
                 class="mt-4 mb-4"               
               ></v-text-field> <!-- En class mt-4 es para tener espacio hacia arriba para que pueda verse el subtitulo Fecha de modificacion -->

                <v-text-field
                  v-model="atributosBuscar"
                  
                  label="Buscar en archivos"
                  variant="outlined"
                  density="comfortable"
                  class="mb-4"
                ></v-text-field>
              </v-window-item>
            </v-window>

            <!-- Botones Buscar y Limpiar -->
            <v-row>
              <v-col cols="6">
                <v-btn
                  color="#ce501b"
                  block
                  @click="buscar"
                  :loading="buscando"
                >
                  Buscar
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  color="#9B9B9B"
                  variant="outlined"
                  block
                  @click="limpiar"
                >
                  Limpiar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Panel derecho: Resultados (sin cambios) -->
      <v-col cols="12" md="9">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center" style="background-color: #def2ff;">
            <span class="text-h6">Cantidad de Expedientes</span>
             
            <!-- ✅ NUEVO: Menu selector de columnas -->
            <v-menu
              v-model="menuAgrupar"
              :close-on-content-click="false"
              location="bottom"
              max-width="300"
            >

            <!-- 
              <template v-slot:activator="{ props }">
                <v-btn
                  size="small"
                  variant="outlined"
                  prepend-icon="mdi-group"
                  v-bind="props"
                >
                  {{ columnaAgrupada ? `Agrupado por: ${getColumnTitle(columnaAgrupada)}` : 'Agrupar por' }}
                </v-btn>
              </template>
            -->
              <v-card min-width="300">
                <v-card-text class="pa-3">
                  <!-- Campo de búsqueda -->
                  <v-text-field
                    v-model="busquedaColumna"
                    placeholder="Buscar columna..."
                    density="compact"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    hide-details
                    class="mb-2"
                  ></v-text-field>

                  <v-divider class="my-2"></v-divider>

                  <!-- Lista de columnas con scroll -->
                     <!-- Lista de columnas con scroll -->
                  <div style="max-height: 300px; overflow-y: auto;">
                    <!-- Opción: Sin agrupar -->
                    <v-radio-group v-model="columnaSeleccionadaTemp" hide-details>
                      <v-radio
                        label="[Seleccionar Todo] (Sin agrupar)"
                        :value="null"
                        density="compact"
                        class="mb-1"
                      ></v-radio>

                      <v-divider class="my-1"></v-divider>

                      <!-- Radio buttons de columnas filtradas -->
                      <v-radio
                        v-for="columna in columnasFiltradas"
                        :key="columna.key"
                        :label="columna.title"
                        :value="columna.key"
                        density="compact"
                        class="mb-1"
                      ></v-radio>
                    </v-radio-group>

                    <!-- Mensaje si no hay resultados -->
                    <div 
                      v-if="columnasFiltradas.length === 0" 
                      class="text-center text-grey py-4"
                    >
                      No se encontraron columnas
                    </div>
                  </div>

                  <v-divider class="my-2"></v-divider>

                  <!-- Botones de acción -->
                  <div class="d-flex gap-2">
                    <v-btn
                      size="small"
                      color="primary"
                      variant="flat"
                      @click="aplicarAgrupamiento"
                      block
                    >
                      Aplicar
                    </v-btn>
                    <v-btn
                      size="small"
                      variant="outlined"
                      @click="cerrarMenu"
                      block
                    >
                      Cerrar
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>

          </v-card-title>
           
        <v-card-text>
          
          <!-- ✅ Una tabla por cada templateId con sus propias columnas -->
      <div v-for="grupo in resultadosPorGrupo" :key="grupo.templateId">

        <!-- Encabezado del grupo con su propio botón Agrupar por -->
        <div class="d-flex align-center px-4 py-2 mb-1"
          style="background-color: #def2ff; border-left: 4px solid #ce501b;">
          
          <span style="font-weight: 600; font-size: 0.85rem; color: #37495f; flex: 1;">
            Plantilla ID: {{ grupo.templateId }} — {{ grupo.items.length }} registro(s)
          </span>

          <!-- ✅ Botón Agrupar por propio de cada grupo -->
          <v-menu
            v-model="getGrupo(grupo.templateId).menu"
            :close-on-content-click="false"
            location="bottom"
            max-width="300"
          >
            <template v-slot:activator="{ props }">
              <v-btn size="small" variant="outlined" prepend-icon="mdi-group" v-bind="props">
                {{ getGrupo(grupo.templateId).columna 
                    ? `Agrupado: ${getGrupo(grupo.templateId).columna}` 
                    : 'Agrupar por' }}
              </v-btn>
            </template>

            <v-card min-width="280">
              <v-card-text class="pa-3">
                <v-text-field
                  v-model="getGrupo(grupo.templateId).busqueda"
                  placeholder="Buscar columna..."
                  density="compact" variant="outlined"
                  prepend-inner-icon="mdi-magnify"
                  clearable hide-details class="mb-2"
                ></v-text-field>

                <v-divider class="my-2"></v-divider>

                <div style="max-height: 250px; overflow-y: auto;">
                  <v-radio-group v-model="getGrupo(grupo.templateId).temp" hide-details>
                    <v-radio label="[Sin agrupar]" :value="null" density="compact" class="mb-1"></v-radio>
                    <v-divider class="my-1"></v-divider>
                    <v-radio
                      v-for="col in grupo.headers.filter(h =>
                        h.key !== 'checkbox' &&
                        h.key !== 'documento' &&
                        (!getGrupo(grupo.templateId).busqueda ||
                        h.title.toLowerCase().includes(getGrupo(grupo.templateId).busqueda.toLowerCase()))
                      )"
                      :key="col.key"
                      :label="col.title"
                      :value="col.key"
                      density="compact"
                      class="mb-1"
                    ></v-radio>
                  </v-radio-group>
                </div>

                <v-divider class="my-2"></v-divider>
                <div class="d-flex gap-2">
                  <v-btn size="small" color="primary" variant="flat"
                    @click="aplicarAgrupamientoGrupo(grupo.templateId)" block>
                    Aplicar
                  </v-btn>
                  <v-btn size="small" variant="outlined"
                    @click="cerrarMenuGrupo(grupo.templateId)" block>
                    Cerrar
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-menu>

        </div>

        <!-- Tabla del grupo con su propio group-by -->
        <v-data-table
          :headers="grupo.headers"
          :items="grupo.items"
          :loading="buscando"
          :group-by="getGrupo(grupo.templateId).columna 
            ? [{ key: getGrupo(grupo.templateId).columna }] 
            : []"
          density="comfortable"
          class="elevation-1 mb-6"
          :items-per-page="itemsPorPagina"
          @update:items-per-page="itemsPorPagina = $event"
        >
          <template v-slot:item="{ item, columns }">
            <tr
              @click="cargarDetalleExpediente(item)"
              @dblclick="visualizarDocumento(item)"
              :class="{ 'fila-seleccionada': expedienteSeleccionado?.tocid === item.tocid }"
              style="cursor: pointer;"
            >
              <td v-for="column in columns" :key="column.key">
                <template v-if="column.key === 'checkbox'">
                  <v-checkbox hide-details density="compact"></v-checkbox>
                </template>
                <template v-else>
                  {{ formatearValorCelda(item[column.key], column.key) }}
                </template>
              </td>
            </tr>
          </template>

          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr class="bg-blue-lighten-4" style="cursor: pointer;">
              <td :colspan="columns.length" @click="toggleGroup(item)">
                <v-btn
                  :icon="isGroupOpen(item) ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline'"
                  size="small" variant="text" density="compact"
                ></v-btn>
                <span class="font-weight-bold ml-2">
                  {{ getGrupo(grupo.templateId).columna }}: {{ formatearValorCelda(item.value) || '(Vacío)' }}
                </span>
                <span class="text-grey ml-2">({{ item.items.length }} registros)</span>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <div class="text-center py-4">Ningún dato disponible</div>
          </template>
        </v-data-table>

      </div>

        <!-- Mensaje si no hay resultados en ningún grupo -->
        <div v-if="resultadosPorGrupo.length === 0 && !buscando" class="text-center py-4 text-grey">
          Ningún dato disponible en esta tabla
        </div>

            <!-- Tabs: Texto, Anotaciones, Detalle (sin cambios) -->
            <v-tabs v-model="tabResultados" color="primary" class="mb-4">
              <v-tab value="texto">Texto</v-tab>
              <v-tab value="anotaciones">Anotaciones</v-tab>
              <v-tab value="detalle">Atributos</v-tab>
            </v-tabs>

            <v-window v-model="tabResultados">
              <!-- Tab Texto -->
              <v-window-item value="texto">
                <v-data-table
                  :headers="headersTexto"
                  :items="datosTexto"
                  density="comfortable"
                  class="elevation-1 mi-tabla"
                  items-per-page="5"
                  :loading="cargandoTabs" 
                >
                   <!-- ✅ NUEVO: renderizar el texto con las coincidencias resaltadas -->
                    <template #[`item.texto`]="{ item }">
                      <div v-html="resaltarCoincidencias(item.texto)"></div>
                    </template>
                    
                  <template v-slot:no-data>
                    <div class="text-center py-4">
                      Ningún dato disponible en esta tabla
                    </div>
                  </template>
                </v-data-table>
              </v-window-item>

              <!-- Tab Anotaciones -->
              <v-window-item value="anotaciones">
                <v-data-table
                  :headers="headersAnotaciones"
                  :items="datosAnotaciones"
                  density="comfortable"
                  class="elevation-1 mi-tabla"
                  items-per-page="5"
                  :loading="cargandoTabs" 
                >
                  <template v-slot:no-data>
                    <div class="text-center py-4">
                      Ningún dato disponible en esta tabla
                    </div>
                  </template>
                </v-data-table>
              </v-window-item>

              <!-- Tab Detalle -->
              <v-window-item value="detalle">
                <v-data-table
                  :headers="headersDetalle"
                  :items="datosDetalle"
                  density="comfortable"
                  class="elevation-1 mi-tabla"
                  items-per-page="5"
                  :loading="cargandoTabs"
                >
                  <template v-slot:no-data>
                    <div class="text-center py-4">
                      Ningún dato disponible en esta tabla
                    </div>
                  </template>
                </v-data-table>
              </v-window-item>
            </v-window>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>



<!-- ============================================================== -->
<!-- DIALOG: VISOR DE DOCUMENTO (Búsqueda Avanzada)                 -->
<!-- ============================================================== -->
<v-dialog v-model="dialogVisor" max-width="1400px" persistent class="dialog-indexacion">
  <v-card style="height: 100%; display: flex; flex-direction: column; overflow: hidden;">
    
    <!-- Header -->
    <v-card-title class="text-h6 bg-primary text-white d-flex align-center py-2 px-4" style="flex-shrink: 0;">
      <v-icon class="mr-2">mdi-file-document-outline</v-icon>
      Visor de Documento
      <v-spacer></v-spacer>
      <v-btn icon size="small" variant="text" @click="cerrarVisorDocumento">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <!-- Contenido principal: 2 columnas -->
    <div style="display: flex; flex: 1; overflow: hidden; min-height: 0;">

      <!-- ===== PANEL IZQUIERDO: VISOR ===== -->
      <div style="flex: 7; display: flex; flex-direction: column; border-right: 1px solid #e0e0e0; min-height: 0;">

        <!-- Barra de herramientas -->
        <div class="d-flex align-center pa-1" style="border-bottom: 1px solid #e0e0e0; background: #f5f5f5; flex-shrink: 0;">
        
          <v-btn v-if="AccesoImprimir" icon size="x-small" variant="text" title="Imprimir" @click="imprimirDocumento"><v-icon size="16">mdi-printer-outline</v-icon></v-btn>

          <v-divider vertical class="mx-1"></v-divider>

          <!-- Botón activar/desactivar modo anotación -->
          <v-btn
            :icon="false"
            v-if="AccesoAnotacion"
            size="x-small"
            :variant="modoAnotacion ? 'flat' : 'text'"
            :color="modoAnotacion ? 'orange' : undefined"
            title="Modo anotación"
            @click="modoAnotacion = !modoAnotacion"
          >
            <v-icon size="16" class="mr-1">mdi-marker</v-icon>
            <span style="font-size: 11px;">{{ modoAnotacion ? 'Anotando...' : 'Anotar' }}</span>
          </v-btn>

          <!-- Botón guardar anotaciones -->
          <v-btn
            v-if="anotaciones.length > 0"
            :icon="false"
            size="x-small"
            variant="text"
            color="success"
            title="Guardar anotaciones"
            @click="guardarAnotaciones"
          >
            <v-icon size="16" class="mr-1">mdi-content-save</v-icon>
            <span style="font-size: 11px;">Guardar ({{ anotaciones.length }})</span>
          </v-btn>
        </div>

        <!-- Área del visor -->
        <div 
          style="flex: 1; background: #808080; overflow: hidden; min-height: 0; position: relative;"
          :style="{ cursor: modoAnotacion ? 'crosshair' : 'default' }"
          @click="agregarAnotacion"
        >

          <!-- Cargando -->
          <div v-if="cargandoVisor" style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
              <p class="text-white mt-2 text-body-2">Cargando documento...</p>
            </div>
          </div>

          <!-- Error -->
          <div v-else-if="errorVisor" style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <v-icon size="48" color="white">mdi-file-alert-outline</v-icon>
              <p class="text-white mt-2 text-body-2">No se pudo cargar el documento</p>
              <p class="text-white text-caption">{{ errorVisor }}</p>
            </div>
          </div>

          <!-- Documento Word: descarga disponible, sin intentar renderizar -->
          <div v-else-if="archivoNoVisualizable"
            style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center px-4">
              <v-icon size="64" color="white">mdi-file-word-outline</v-icon>
              <p class="text-white text-body-1 font-weight-medium mt-3">Documento Word</p>
              <p class="text-white text-body-2 mt-2">Este formato no puede visualizarse directamente.</p>
              <v-btn class="mt-4" color="primary" @click.stop="descargarDocumentoWord">
                <v-icon start>mdi-download</v-icon>
                Descargar archivo
              </v-btn>
            </div>
          </div>

        <!-- ✅ IMAGEN SIMPLE CON ZOOM Y ARRASTRE -->
        <div
          v-else-if="urlVisor && esImagenVisor && !modoPaginasMultiplesVisor"
          ref="visorImagenRef"
          style="position: absolute; inset: 0; overflow: auto; background: #808080; display:flex; justify-content:flex-start; align-items:flex-start;"
          :style="{ cursor: isDragging ? 'grabbing' : (zoomLevel > 1 ? 'grab' : 'default') }"
          @mousedown="onMouseDown"
          @mousemove="onMouseMove"
          @mouseup="onMouseUp"
          @mouseleave="onMouseUp"
          @wheel.prevent="onWheelZoom"
        >
          <div :style="{
            transform: `scale(${zoomLevel})`,
            transformOrigin: 'top left', // ✅ CLAVE: Desde esquina superior izquierda
            transition: isDragging ? 'none' : 'transform 0.15s ease',
            flexShrink: 0,
            width: '100%'
          }">
            <img
              :src="urlVisor"
              style="width:100%; height:auto; display:block; user-select:none; pointer-events:none;"
              alt="Documento"
              draggable="false"
             
            />
          </div>
        </div>

          <!-- ══ VIDEO ══  ← AGREGAR ESTE BLOQUE -->
          <div
            v-else-if="urlVisor && esVideoVisor"
            style="position: absolute; inset: 0; display: flex; flex-direction: column; background: #000;"
          >
            <video
              ref="videoRef"
              :src="urlVisor"
              controls
              style="width: 100%; height: 100%; object-fit: contain;"
              @timeupdate="actualizarSegmentoActual"
            ></video>
          </div>
           

          <!-- ══ AUDIO ══  ← AGREGAR AQUÍ -->
          <div
            v-else-if="urlVisor && esAudioVisor"
            style="position: absolute; inset: 0; display: flex; flex-direction: column;
                  align-items: center; justify-content: center; background: #2a2a2a;"
          >
            <v-icon size="80" color="white" class="mb-4">mdi-music-note</v-icon>
            <p class="text-white text-body-1 mb-6" style="opacity: 0.85;">
              {{ documentoContexto?.documento || 'Audio' }}
            </p>
            <audio
              ref="audioRef"
              :src="urlVisor"
              controls
              style="width: 80%; max-width: 600px;"
              @timeupdate="actualizarSegmentoActual"
            >
              Tu navegador no soporta la reproducción de audio.
            </audio>
          </div>


           <!-- ══ MODO MULTI-PÁGINA ══ -->
          <div
            v-else-if="modoPaginasMultiplesVisor"
            style="position: absolute; inset: 0; display: flex; flex-direction: column; background: #808080;"
          >
            <!-- Barra de navegación -->
            <div style="display:flex; align-items:center; justify-content:center; gap:8px; padding:6px 12px; background:#424242; flex-shrink:0;">
              
              <button @click="cargarPaginaMultipleVisor(1)"
                :disabled="paginaMultipleActualVisor <= 1 || cargandoPaginaMultipleVisor"
                style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                :style="{ opacity: paginaMultipleActualVisor <= 1 ? '0.3' : '0.9' }">«</button>

              <button @click="cargarPaginaMultipleVisor(paginaMultipleActualVisor - 1)"
                :disabled="paginaMultipleActualVisor <= 1 || cargandoPaginaMultipleVisor"
                style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                :style="{ opacity: paginaMultipleActualVisor <= 1 ? '0.3' : '0.9' }">‹</button>

              <span style="color:white; font-size:12px; min-width:80px; text-align:center;">
                Pág. {{ paginaMultipleActualVisor }} / {{ listaPaginasVisor.length }}
              </span>

              <button @click="cargarPaginaMultipleVisor(paginaMultipleActualVisor + 1)"
                :disabled="paginaMultipleActualVisor >= listaPaginasVisor.length || cargandoPaginaMultipleVisor"
                style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                :style="{ opacity: paginaMultipleActualVisor >= listaPaginasVisor.length ? '0.3' : '0.9' }">›</button>

              <button @click="cargarPaginaMultipleVisor(listaPaginasVisor.length)"
                :disabled="paginaMultipleActualVisor >= listaPaginasVisor.length || cargandoPaginaMultipleVisor"
                style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                :style="{ opacity: paginaMultipleActualVisor >= listaPaginasVisor.length ? '0.3' : '0.9' }">»</button>

              <v-progress-circular v-if="cargandoPaginaMultipleVisor"
                indeterminate color="white" size="16" width="2"></v-progress-circular>
            </div>

            <!-- ✅ Área de visualización PAGINADA con ZOOM -->
            <div
              ref="visorImagenPaginaRef"
              style="flex:1; overflow:auto; display:flex; justify-content:flex-start; align-items:flex-start; padding:8px; background:#808080;"
              :style="{ cursor: isDragging ? 'grabbing' : (zoomLevel > 1 ? 'grab' : 'default') }"
              @mousedown="onMouseDown"
              @mousemove="onMouseMove"
              @mouseup="onMouseUp"
              @mouseleave="onMouseUp"
              @wheel.prevent="onWheelZoom"
            >

              <div v-if="cargandoPaginaMultipleVisor" style="display:flex; align-items:center; justify-content:center; width:100%; height:100%;">
                <div class="text-center">
                  <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
                  <p class="text-white mt-2 text-body-2">Cargando página {{ paginaMultipleActualVisor }}...</p>
                </div>
              </div>

              <div v-else-if="errorPaginaMultipleVisor" style="display:flex; align-items:center; justify-content:center; width:100%; height:100%;">
                <div class="text-center">
                  <v-icon size="48" color="white">mdi-file-alert-outline</v-icon>
                  <p class="text-white mt-2 text-body-2">{{ errorPaginaMultipleVisor }}</p>
                </div>
              </div>

          <div :style="{
              transform: `scale(${zoomLevel})`,
              transformOrigin: 'top left',
              transition: isDragging ? 'none' : 'transform 0.15s ease',
              flexShrink: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }">
              <img
                :src="urlPaginaMultipleVisor"
                style="max-width: 100%; max-height: 100%; object-fit: contain; box-shadow: 0 2px 8px rgba(0,0,0,0.4); user-select: none; pointer-events: none;"
                alt="Página"
                draggable="false"
              />
            </div>

            </div>
          </div>

          <!-- PDF iframe -->
           
          <iframe
            v-else-if="urlVisor && !modoPaginasMultiplesVisor"
            :src="urlVisor"
            style="position: absolute; inset: 0; width: 100%; height: 100%; border: none;"
            title="Visor de documento"
          ></iframe>  

      
          <!-- Capa transparente sobre iframe en modo anotación -->
          <div
            v-if="modoAnotacion && urlVisor && !esImagenVisor && !archivoNoVisualizable"
            style="position: absolute; inset: 0; z-index: 5; cursor: crosshair; background: transparent;"
            @click="agregarAnotacion"
          ></div>

          <!-- Sin documento -->
        <div v-else-if="!urlVisor && !cargandoVisor && !errorVisor && !modoPaginasMultiplesVisor && !archivoNoVisualizable"
          style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
          <div class="text-center">
            <v-icon size="64" color="white" style="opacity: 0.5;">mdi-file-document-outline</v-icon>
            <p class="text-white mt-2" style="opacity: 0.7;">Sin documento</p>
          </div>
        </div>

          <!-- ===== ANOTACIONES GUARDADAS ===== -->
          <div
            v-for="(anot, index) in anotaciones"
            :key="'anot-' + index"
            class="sticky-note"
            :style="{ left: anot.x + '%', top: anot.y + '%' }"
            @click.stop
          >
            <div class="sticky-note-header">
              <span class="sticky-note-number">#{{ index + 1 }}</span>
              <div class="sticky-note-actions">
                <v-icon size="14" class="sticky-note-btn" @click.stop="editarAnotacion(index)" title="Editar">mdi-pencil</v-icon>
                <v-icon size="14" class="sticky-note-btn sticky-note-btn-delete" @click.stop="eliminarAnotacion(index)" title="Eliminar">mdi-close</v-icon>
              </div>
            </div>
            <div class="sticky-note-body">{{ anot.texto }}</div>
          </div>

          <!-- ===== NUEVA ANOTACIÓN ===== -->
          <div
            v-if="nuevaAnotacionVisible"
            class="sticky-note sticky-note-editing"
            :style="{ left: nuevaAnotacionX + '%', top: nuevaAnotacionY + '%' }"
            @click.stop
          >
            <div class="sticky-note-header">
              <v-icon size="14" style="color: #b8860b;">mdi-plus</v-icon>
              <span style="font-size: 10px; color: #b8860b; font-weight: 600;">Toma una nota...</span>
              <div class="sticky-note-actions">
                <v-icon size="14" class="sticky-note-btn sticky-note-btn-delete" @click.stop="cancelarAnotacion">mdi-close</v-icon>
              </div>
            </div>
            <textarea
              id="sticky-note-input-busqueda"
              v-model="nuevaAnotacionTexto"
              class="sticky-note-textarea"
              placeholder="Escribe tu anotación..."
              rows="4"
              @keydown.enter.ctrl="confirmarAnotacion"
            ></textarea>
            <div class="sticky-note-footer">
              <button class="sticky-btn sticky-btn-cancel" @click.stop="cancelarAnotacion">Cancelar</button>
              <button class="sticky-btn sticky-btn-save" @click.stop="confirmarAnotacion">Guardar</button>
            </div>
          </div>

        </div>
      </div>

      <!-- ===== PANEL DERECHO: CAMPOS (solo lectura) ===== -->
      <div style="flex: 3; display: flex; flex-direction: column; min-height: 0; max-height: 100%;">
        <div style="flex: 1; overflow-y: auto; padding: 16px; min-height: 0; max-height: calc(97vh - 120px);">

          <div v-if="cargandoEstructuraVisor" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Cargando estructura...</p>
          </div>

          <v-row v-else dense>
            <v-col v-for="campo in estructuraVisor" :key="campo.column_name" cols="12">
              <v-select
                v-if="campo.valores"
                v-model="valoresVisor[campo.column_name]"
                :items="getOpcionesCombo(campo.valores)"
                :label="campo.column_name"
                variant="outlined" density="compact" clearable readonly
              ></v-select>
              <v-text-field
                v-else-if="esCampoFecha(campo.data_type)"
                v-model="valoresVisor[campo.column_name]"
                :label="campo.column_name"
                type="date" variant="outlined" density="compact" readonly
              ></v-text-field>
              <v-text-field
                v-else
                v-model="valoresVisor[campo.column_name]"
                :label="campo.column_name"
                variant="outlined" density="compact" readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Lista de anotaciones -->
          <div v-if="anotaciones.length > 0" class="mt-4">
            <v-divider class="mb-2"></v-divider>
            <p class="text-subtitle-2 mb-2">
              <v-icon size="16" class="mr-1">mdi-marker</v-icon>
              Anotaciones ({{ anotaciones.length }})
            </p>
            <v-list density="compact" class="pa-0">
              <v-list-item
                v-for="(anot, index) in anotaciones"
                :key="'lista-anot-' + index"
                class="px-0"
                style="min-height: 36px;"
              >
                <template v-slot:prepend>
                  <v-icon color="orange" size="16">mdi-note</v-icon>
                </template>
                <v-list-item-title class="text-body-2">{{ anot.texto }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">X: {{ anot.x }}% · Y: {{ anot.y }}%</v-list-item-subtitle>
                <template v-slot:append>
                  <v-btn icon size="x-small" variant="text" color="error" @click="eliminarAnotacion(index)">
                    <v-icon size="14">mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-list-item>
            </v-list>
          </div>

         <!-- ══ SEGMENTOS DE VIDEO / AUDIO ══ -->
        <div v-if="esVideoVisor || esAudioVisor" class="mt-4">
          <v-divider class="mb-3"></v-divider>

          <p class="text-subtitle-2 mb-2">
            <v-icon size="16" class="mr-1" color="primary">
              {{ esVideoVisor ? 'mdi-text-search' : 'mdi-waveform' }}
            </v-icon>
            Resultados en {{ esVideoVisor ? 'video' : 'audio' }}
          </p>

          <!-- Cargando -->
          <div v-if="cargandoBusquedaVideo" class="d-flex align-center justify-center py-3">
            <v-progress-circular indeterminate color="primary" size="20" width="2" class="mr-2"></v-progress-circular>
            <span class="text-caption text-grey">Buscando segmentos...</span>
          </div>

          <!-- Sin resultados -->
          <div v-else-if="!segmentosVideo.length" class="text-center py-3">
            <v-icon color="grey-lighten-1" size="28">
              {{ esVideoVisor ? 'mdi-video-off-outline' : 'mdi-music-off' }}
            </v-icon>
            <p class="text-caption text-grey mt-1">
              {{ textoBuscar ? `Sin coincidencias para "${textoBuscar}"` : 'Sin texto de búsqueda' }}
            </p>
          </div>

          <!-- Lista de segmentos -->
          <v-list v-else density="compact" class="pa-0">
            <v-list-item
              v-for="(seg, idx) in segmentosVideo"
              :key="idx"
              :class="segmentoActualVisor === idx ? 'bg-blue-lighten-4' : ''"
              class="px-2 mb-1 rounded"
              style="cursor: pointer; border: 1px solid #e0e0e0;"
              @click="irASegmento(idx)"
            >
              <template v-slot:prepend>
                <v-icon
                  :color="segmentoActualVisor === idx ? 'primary' : 'grey-lighten-1'"
                  size="18"
                >
                  {{ segmentoActualVisor === idx
                      ? (esVideoVisor ? 'mdi-play-circle' : 'mdi-play-circle')
                      : (esVideoVisor ? 'mdi-play-circle-outline' : 'mdi-music-note-outline') }}
                </v-icon>
              </template>

              <v-list-item-title class="text-body-2 text-wrap" style="white-space: normal;">
                {{ seg.texto }}
              </v-list-item-title>

              <v-list-item-subtitle class="text-caption" style="color: #1976d2;">
                {{ formatearTiempoVideo(seg.comienzo) }} → {{ formatearTiempoVideo(seg.fin) }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>

        </div>


        </div>
      </div>
    </div>

  </v-card>
</v-dialog>



  </v-container>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, onUnmounted, computed, watch, nextTick } from 'vue';
import axios from '@/plugins/axios'
import { buildApiUrl } from '@/config/api'
import Swal from 'sweetalert2';
import UTIF from 'utif';
import { useDescargas } from '@/components/experimental/Usedescargas'


// ✅ NUEVAS VARIABLES PARA ZOOM Y ARRASTRE DE IMÁGENES
const zoomLevel = ref(1);
const isDragging = ref(false);
const startX = ref(0);
const startY = ref(0);
const scrollLeft = ref(0);
const scrollTop = ref(0);

// ✅ NUEVA: Para que se ajuste automáticamente al abrir
const escalaInicial = ref(1);

// ✅ ESTOS SON LOS QUE FALTABAN: referencias al DOM
const visorImagenRef = ref(null);
const visorImagenPaginaRef = ref(null);




// ✅ FUNCIONES DE ZOOM Y ARRASTRE
const onWheelZoom = (e) => {
  e.preventDefault();
  const factor = e.deltaY > 0 ? 0.9 : 1.1;
  // Zoom entre 0.5x y 5x sobre el tamaño inicial
  zoomLevel.value = Math.max(0.5, Math.min(5, zoomLevel.value * factor));
};

const onMouseDown = (e) => {
  // Solo activar si hay zoom mayor a 1
  if (zoomLevel.value > 1) {
    isDragging.value = true;
    // ✅ CORREGIDO: Usamos nuestras variables ref
    const refElement = esImagenVisor.value ? visorImagenRef.value : visorImagenPaginaRef.value;
    if (!refElement) return;
    startX.value = e.pageX - refElement.offsetLeft;
    startY.value = e.pageY - refElement.offsetTop;
    scrollLeft.value = refElement.scrollLeft;
    scrollTop.value = refElement.scrollTop;
  }
}

const onMouseMove = (e) => {
  if (!isDragging.value) return;
  e.preventDefault();
  // ✅ CORREGIDO
  const refElement = esImagenVisor.value ? visorImagenRef.value : visorImagenPaginaRef.value;
  if (!refElement) return;
  const x = e.pageX - refElement.offsetLeft;
  const y = e.pageY - refElement.offsetTop;
  const walkX = (x - startX.value) * 1.2; // Velocidad de arrastre
  const walkY = (y - startY.value) * 1.2;
  refElement.scrollLeft = scrollLeft.value - walkX;
  refElement.scrollTop = scrollTop.value - walkY;
};

const onMouseUp = () => {
  isDragging.value = false;
};


const AccesoImprimir = ref(false);

const props = defineProps({
  busquedaCarpeta: {
    type: Object,
    default: null
  }
});

const AccesoAnotacion = ref(false);

// ── VARIABLES PARA VISOR DE VIDEO ──
const esVideoVisor = ref(false)
const videoRef = ref(null)
const segmentosVideo = ref([])
const segmentoActualVisor = ref(-1)
const cargandoBusquedaVideo = ref(false)

const esAudioVisor = ref(false)
const audioRef    = ref(null)


// ============================================================
// FUNCIONES PARA VISOR DE VIDEO
// ============================================================

// Convierte el formato "SS.ms" del backend a segundos reales para el video
// Ejemplo: 3.02 → 3 segundos + 2 ms = 3.002s
const convertirTiempoVideo = (t) => {
  const segundos = Math.floor(t)
  const ms = Math.round((t % 1) * 100)   // 0.02 × 100 = 2 ms
  return segundos + ms / 1000             // 3 + 0.002 = 3.002
}

// Formatea el tiempo para mostrar en pantalla: "3.02s" o "1:03.16"
const formatearTiempoVideo = (t) => {
  const segs = Math.floor(t)
  const ms = Math.round((t % 1) * 100)
  const min = Math.floor(segs / 60)
  const sec = segs % 60
  const msStr = String(ms).padStart(2, '0')
  if (min > 0) {
    return `${min}:${String(sec).padStart(2, '0')}.${msStr}`
  }
  return `${sec}.${msStr}s`
}

// Salta el video al segmento seleccionado
const irASegmento = (idx) => {
  const seg = segmentosVideo.value[idx]
  if (!seg) return

  const t1 = convertirTiempoVideo(seg.comienzo)
  const t2 = convertirTiempoVideo(seg.fin)
  const tiempoInicio = Math.min(t1, t2)
  segmentoActualVisor.value = idx

  if (esVideoVisor.value && videoRef.value) {
    const video = videoRef.value
    video.pause()
    video.currentTime = tiempoInicio
    video.addEventListener('seeked', () => {
      video.play().catch(() => {})
    }, { once: true })
  } else if (esAudioVisor.value && audioRef.value) {
    const audio = audioRef.value
    audio.pause()
    audio.currentTime = tiempoInicio
    audio.addEventListener('seeked', () => {
      audio.play().catch(() => {})
    }, { once: true })
  }
}


// Resalta el segmento actual mientras se reproduce el video
const actualizarSegmentoActual = () => {

const reproductor = esVideoVisor.value ? videoRef.value
                    : esAudioVisor.value ? audioRef.value
                    : null

  if (!reproductor || !segmentosVideo.value.length) return

    const t = reproductor.currentTime
    const idx = segmentosVideo.value.findIndex(seg => {
    const t1 = convertirTiempoVideo(seg.comienzo)
    const t2 = convertirTiempoVideo(seg.fin)
    return t >= Math.min(t1, t2) && t <= Math.max(t1, t2)
  })
  if (idx !== -1) segmentoActualVisor.value = idx
}

// Llama al API de búsqueda en video y obtiene los segmentos
const buscarEnVideo = async (plantillaId) => {
 
  const texto = textoBuscar.value?.trim()
  if (!texto) return

  cargandoBusquedaVideo.value = true
  segmentosVideo.value = []

  try {
    const response = await axios.get(
      `/api/Busqueda/avanzada-video`,
      { params: { plantillaId, texto } }
    )
    if (response.data.success) {
      segmentosVideo.value = response.data.data || []
      // ✅ Al abrir el visor, posicionar automáticamente en el primer resultado
      await mostrarPrimerResultadoVideo()
    }
  } catch {
    // Sin resultados o error silencioso en el visor
  } finally {
    cargandoBusquedaVideo.value = false
  }
}


const mostrarPrimerResultadoVideo = async () => {
  if (!segmentosVideo.value.length) return

  await nextTick()

  const reproductor = esVideoVisor.value ? videoRef.value
                      : esAudioVisor.value ? audioRef.value
                      : null
  if (!reproductor) return

  segmentoActualVisor.value = 0
  const tiempoInicio = convertirTiempoVideo(segmentosVideo.value[0].comienzo)

  const posicionar = () => {
    try { reproductor.currentTime = tiempoInicio } catch (e) { /* ignorar */ }
  }

  // Si los metadatos del media aún no cargaron, esperar el evento
  if (reproductor.readyState >= 1) {
    posicionar()
  } else {
    reproductor.addEventListener('loadedmetadata', posicionar, { once: true })
  }
}


// ============================================================
// VARIABLES PARA VISOR DE DOCUMENTO
// ============================================================
const dialogVisor = ref(false);
const urlVisor = ref('');
const cargandoVisor = ref(false);
const errorVisor = ref('');
const esImagenVisor = ref(false);
const estructuraVisor = ref([]);
const valoresVisor = ref({});
const cargandoEstructuraVisor = ref(false);
const documentoContexto = ref(null);
const cargandoTabs = ref(false);
const archivoNoVisualizable = ref(false);
const { procesarDescargaArchivo } = useDescargas()


// Anotaciones
const anotaciones = ref([]);
const modoAnotacion = ref(false);
const nuevaAnotacionVisible = ref(false);
const nuevaAnotacionX = ref(0);
const nuevaAnotacionY = ref(0);
const nuevaAnotacionTexto = ref('');
const editandoAnotacionIndex = ref(null);


// Variables reactivas
const plantillas = ref([]);
const plantillaSeleccionada = ref(null);
const camposBusqueda = ref([]);
const valoresBusqueda = ref({});
const tabBusqueda = ref('texto');

// ✅ VARIABLES PARA BÚSQUEDA EN TEXTO
const textoBuscar = ref('');
const textoBuscar2 = ref('');           // Segundo término (aproximada)
const textoOperador = ref('Y');         // Operador Y/O
const textoRadio = ref('1');            // 1=Exacta, 2=Aproximada
const excluirTextoActivo = ref(false);  // Checkbox excluir
const textoExcluir = ref('');           // Texto a excluir

// ✅ VARIABLES PARA BÚSQUEDA EN ANOTACIONES
const anotacionesBuscar = ref('');
const anotacionesBuscar2 = ref('');     // Segundo término (aproximada)
const anotacionesOperador = ref('Y');   // Operador Y/O
const anotacionesRadio = ref('1');      // 1=Exacta, 2=Aproximada

// ✅ VARIABLES PARA BÚSQUEDA EN ATRIBUTOS
const atributosBuscar = ref('');
const fechaAtributos = ref(null);

// ✅ Opciones para el selector de operador
const opcionesOperador = ref([
  { text: 'Y', value: 'Y' },
  { text: 'O', value: 'O' }
]);


const buscando = ref(false);
const resultados = ref([]);
const tabResultados = ref('texto');
const datosTexto = ref([]);
const datosAnotaciones = ref([]);
const datosDetalle = ref([]);
const expedienteSeleccionado = ref(null);

const modoPaginasMultiplesVisor = ref(false)
const listaPaginasVisor = ref([])
const paginaMultipleActualVisor = ref(1)
const urlPaginaMultipleVisor = ref('')
const cargandoPaginaMultipleVisor = ref(false)
const esImagenPaginaMultipleVisor = ref(false)
const errorPaginaMultipleVisor = ref('')


// ✅ NUEVAS VARIABLES para selector de columnas
  const menuAgrupar = ref(false);
  const busquedaColumna = ref('');
  const columnaAgrupada = ref(null);
  const columnaSeleccionadaTemp = ref(null);

const agrupamientoPorGrupo = ref({}) 

const initGrupo = (templateId) => {
  if (!agrupamientoPorGrupo.value[templateId]) {
    agrupamientoPorGrupo.value[templateId] = {
      columna: null,
      temp: null,
      menu: false,
      busqueda: ''
    }
  }
  return agrupamientoPorGrupo.value[templateId]
}


const getGrupo = (templateId) => agrupamientoPorGrupo.value[templateId] || initGrupo(templateId)


const aplicarAgrupamientoGrupo = (templateId) => {
  const g = getGrupo(templateId)
  g.columna = g.temp
  g.menu = false
  if (g.columna) {
    Swal.fire({
      icon: 'success', iconColor: '#ce501b',
      title: 'Agrupamiento aplicado',
      text: `Agrupando por: ${g.columna}`,
      timer: 2000, showConfirmButton: false,
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
  }
}


const cerrarMenuGrupo = (templateId) => {
  const g = getGrupo(templateId)
  g.menu = false
  g.busqueda = ''
}




const itemsPorPagina = ref(10);


// ✅ Headers dinámicos (se actualizarán según plantilla)
const headersExpedientes = ref([
  { title: '', key: 'checkbox', sortable: false, width: '50px' }
]);

const headersTexto = ref([
  //{ title: 'NroPag', key: 'nroPag', sortable: true },
  //{ title: 'Ocurrencias', key: 'ocurrencias', sortable: true },
  { title: 'Contenido de Texto', key: 'texto', sortable: false }
]);

const headersAnotaciones = ref([
//{ title: 'NroPag', key: 'nroPag', sortable: true },
  { title: 'Anotaciones de Texto', key: 'Texto', sortable: true }
]);

const headersDetalle = ref(
    [
      { title: 'Campo', key: 'Campo', sortable: true },
      { title: 'Descripcion', key: 'Descripcion', sortable: true }     
    ]
);

// ── Atajo de teclado ESC para cerrar el Visor de Documento ──
const handleKeyboardShortcutBusqueda = (event) => {
  if (event.key === 'Escape') {
    if (dialogVisor.value) {
      event.preventDefault()
      cerrarVisorDocumento()
    }
  }
}

const cerrarVisorDocumento = () => {
  dialogVisor.value = false
  archivoNoVisualizable.value = false
}

// Cargar plantillas al montar
onMounted(async () => {
  await cargarPlantillas();
  AccesoAnotacion.value = Number(localStorage.getItem('anotaciones')) === 1; 
  AccesoImprimir.value = Number(localStorage.getItem('impresion')) === 1;

    // ✅ Registrar atajo de teclado
  document.addEventListener('keydown', handleKeyboardShortcutBusqueda)
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyboardShortcutBusqueda)
})

// ✅ Funciones auxiliares
const getOpcionesCombo = (valores) => {
  if (!valores) return [];
  return valores.split(',').map(v => v.trim());
};

const esCampoFecha = (tipo) => {
  if (!tipo) return false;
  const tipoLower = tipo.toLowerCase();
  return tipoLower.includes('date') || tipoLower.includes('datetime');
};


// ✅ AGREGAR función para cerrar menú
const cerrarMenu = () => {
  menuAgrupar.value = false;
  busquedaColumna.value = '';
};

// ✅ FUNCIÓN: Obtener título de columna
const getColumnTitle = (key) => {
  const header = headersExpedientes.value.find(h => h.key === key);
  return header ? header.title : key;
};


// ✅ FUNCIÓN: Aplicar agrupamiento
const aplicarAgrupamiento = () => {
  columnaAgrupada.value = columnaSeleccionadaTemp.value;

  if (columnaAgrupada.value) {
    Swal.fire({
      icon: 'success',
      iconColor: '#ce501b',
      title: 'Agrupamiento aplicado',
      text: `Agrupando por: ${getColumnTitle(columnaAgrupada.value)}`,
      timer: 2000,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      showConfirmButton: false
    });
  }

  menuAgrupar.value = false;
};

// ✅ COMPUTED: Columnas disponibles para agrupar (sin checkbox y sin documento)
const columnasDisponibles = computed(() => {
  return headersExpedientes.value.filter(header => 
    header.key !== 'checkbox' && 
    header.key !== 'actions' && 
    header.key.toLowerCase() !== 'documento'
  );
});


// ✅ COMPUTED: Filtrar columnas según búsqueda
const columnasFiltradas = computed(() => {
  if (!busquedaColumna.value) {
    return columnasDisponibles.value;
  }
  
  const busqueda = busquedaColumna.value.toLowerCase();
  return columnasDisponibles.value.filter(columna =>
    columna.title.toLowerCase().includes(busqueda)
  );
});


// ✅ WATCH: Actualizar estado de "Seleccionar Todo"

watch(menuAgrupar, (nuevoValor) => {
  if (nuevoValor) {
    columnaSeleccionadaTemp.value = columnaAgrupada.value;
  }
});



// ── AGREGA esta función completa en el <script setup> ──
const cargarDetalleExpediente = async (item) => {
  const tocId = item.tocid;
  if (!tocId) return;

  // Marcar fila seleccionada
  expedienteSeleccionado.value = item;

  // Limpiar datos anteriores
  datosTexto.value = [];
  datosAnotaciones.value = [];
  datosDetalle.value = [];
  cargandoTabs.value = true;

  try {
    const [resTexto, resAnotaciones, resDetalle] = await Promise.all([
      axios.get(`/api/Busqueda/texto/${tocId}`),
      axios.get(`/api/Busqueda/anotaciones/${tocId}`),
      axios.get(`/api/Busqueda/Detalle/${tocId}`)
    ]);

    // ── Tab TEXTO ──
    if (resTexto.data.success && resTexto.data.data?.length > 0) {
      datosTexto.value = resTexto.data.data.map(d => ({
        texto: d.texto || d.Texto || '-'
      }));
    }

    // ── Tab ANOTACIONES ──
    if (resAnotaciones.data.success && resAnotaciones.data.data?.length > 0) {
      datosAnotaciones.value = resAnotaciones.data.data.map(d => ({
        Texto: d.texto || d.Texto || '-'
      }));
    }

    // ── Tab ATRIBUTOS / DETALLE ──
    if (resDetalle.data.success && resDetalle.data.data?.length > 0) {
      datosDetalle.value = resDetalle.data.data.map(d => ({
        Campo:       d.nombre_Campo || '-',
        Descripcion: d.tipo || '-'
      }));
    }

  } catch (error) {
    //console.error('Error al cargar detalle del expediente:', error);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudo cargar el detalle del expediente',
      timer: 2500,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      showConfirmButton: false
    });
  } finally {
    cargandoTabs.value = false;
  }
};



// Funciones
const cargarPlantillas = async (idPlantilla) => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
   if (idPlantilla) { 
        const response = await axios.get(
      `/api/Plantillas/buscar-plantillas/${idPlantilla}?idUsuarioSesion=${idUsuarioSesion}`
         );
   
        plantillas.value = response.data.data;

   } else {
        const response = await axios.get(
      `/api/Plantillas/list-plantillas?idUsuarioSesion=${idUsuarioSesion}`
    );
   
    if (response.data.success) {
      plantillas.value = response.data.data;
    }
   }

   
  } catch (error) {
    //console.error('Error al cargar plantillas:', error);     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudieron cargar las plantillas',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};


watch(() => props.busquedaCarpeta, async (datos) => {
  if (!datos) return;

  //console.log('=== WATCH DISPARADO ===', datos);  //Usarlo solo para ver los errores en el testeo de Software

  // ══════════════════════════════════════════════
  // CASO 1: BÚSQUEDA POR LOTE → usa API avanzada-Lote
  // ══════════════════════════════════════════════
  if (datos.busquedaLote) {
    const lote = datos.busquedaLote;
   
    // 1. Cargar todas las plantillas y seleccionar la del lote
    await cargarPlantillas();
    plantillaSeleccionada.value = parseInt(lote.plantillaId);

    // 2. Cargar campos de la plantilla (genera headers y campos dinámicos)
    await cargarCamposPlantilla();

    // 3. Configurar el formulario visual: Tab "Texto", modo "Exacta", texto del archivo
    tabBusqueda.value = 'texto';
    textoRadio.value = '1';           // Exacta
    textoBuscar.value = lote.texto;   // Contenido del archivo .txt visible en el campo

    // 4. Llamar al API de búsqueda por lote
    try {
      buscando.value = true;
      const idUsuarioSesion = localStorage.getItem('idUsuario');

      const requestBody = {
        PlantillaId: '|' + lote.plantillaId,                              // Requerido > 0 por el API
        Columna: lote.columna,
        Texto: lote.texto                     // Contenido del archivo .txt
      };

      const response = await axios.post(
        `/api/Busqueda/avanzada-Lote?idUsuarioSesion=${idUsuarioSesion}`,
        requestBody
      );


      if (response.data.success) {
        resultados.value = response.data.data;
        columnaAgrupada.value = null;


        if (resultados.value.length === 0) {
          Swal.fire({ 
          icon: 'info', 
          iconColor: '#ce501b',
          title: 'Sin resultados', 
          text: 'No se encontraron expedientes con el texto del archivo',
          confirmButtonColor: '#ce501b',
          customClass: {
              title: 'swal-title-custom',
              container: 'swal-sobre-modal',
              confirmButton: 'swal-btn-confirmar'
           }
           });
        } else {
          Swal.fire({
            icon: 'success',
            iconColor: '#ce501b',
            title: 'Búsqueda por Lote',
            text: `Se encontraron ${resultados.value.length} resultado(s) - Columna: ${lote.columna}`,
            timer: 2500,
            customClass: {
              title: 'swal-title-custom',
              container: 'swal-sobre-modal'
           },
            showConfirmButton: false
          });
        }
      } else {
        Swal.fire({ icon: 'warning', title: 'Advertencia', text: response.data.mensaje || 'No se encontraron resultados' });
        resultados.value = [];
      }

    } catch (error) {
      //console.error('[LOTE] Error:', error);   //Usarlo solo para ver los errores en el testeo de Software
      //console.error('[LOTE] Detalle:', error.response?.data);  //Usarlo solo para ver los errores en el testeo de Software
      //console.error('[LOTE] Errors:', error.response?.data?.errors);  //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error en Búsqueda por Lote',
        text: error.response?.data?.mensaje || 'Hubo un problema al realizar la búsqueda por lote',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
      resultados.value = [];
    } finally {
      buscando.value = false;
    }

    return;  // Salir, no ejecutar los otros casos
  }

  // ══════════════════════════════════════════════
  // CASO 2: BÚSQUEDA EN CARPETA (con estructura precargada)
  // ══════════════════════════════════════════════
  if (datos.estructuraCargada && datos.estructuraCargada.length > 0) {
    await cargarPlantillas(datos.plantillaId);
    procesarEstructura(datos.estructuraCargada, datos.plantillaId);

    if (!plantillaSeleccionada.value && plantillas.value.length > 0) {
      plantillaSeleccionada.value = plantillas.value[0].codigo;
    }

    if (plantillaSeleccionada.value) {
      await buscar(datos.tocId);
    }

    Swal.fire({
      icon: 'info',
      iconColor: '#ce501b',
      title: 'Búsqueda en Carpeta',
      text: `Buscando en la Carpeta: ${datos.nombreCarpeta}`,
      timer: 2000,
      showConfirmButton: false,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
    return;
  }

  // ══════════════════════════════════════════════
  // CASO 3: FLUJO NORMAL (sin estructura precargada)
  // ══════════════════════════════════════════════
  if (datos.plantillaId > 0) {
    await cargarPlantillas();
    plantillaSeleccionada.value = datos.plantillaId;
    await cargarCamposPlantilla();
  }
}, { immediate: true });



const cargarCamposPlantilla = async () => {
  if (!plantillaSeleccionada.value) return;

  try {
    const response = await axios.get(
      `/api/Plantillas/estructura/${plantillaSeleccionada.value}`
    );

    if (response.data.success) {
      // ✅ Guardar TODA la información (nombre, tipo, valores)
      camposBusqueda.value = response.data.data.map(campo => ({
        nombre: campo.column_name,
        tipo: campo.data_type,
        valores: campo.valores
      }));

      //console.log('Campos cargados:', camposBusqueda.value);  //Usarlo solo para ver los errores en el testeo de Software

      // ✅ GENERAR HEADERS DINÁMICOS PARA LA TABLA
      headersExpedientes.value = [
        { title: '', key: 'checkbox', sortable: false, width: '50px' },
        // Agregar cada campo como columna
        ...camposBusqueda.value.map(campo => ({
          title: campo.nombre,
          key: campo.nombre.toLowerCase(), // Usar minúsculas para el key
          sortable: true
        })),
         { title: 'DOCUMENTO', key: 'documento', sortable: true }
      ];

      //console.log('Headers generados:', headersExpedientes.value);  //Usarlo solo para ver los errores en el testeo de Software

      // Inicializar valores vacíos
      valoresBusqueda.value = {};
      camposBusqueda.value.forEach(campo => {
        valoresBusqueda.value[campo.nombre] = '';
      });
    }
  } catch (error) {
    //console.error('Error al cargar campos:', error);   //Usarlo solo para ver los errores en el testeo de Software
  }
};



const tocIdCarpetaActual = ref(0)


const buscar = async (tocId) => {
  if (!plantillaSeleccionada.value) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      iconColor: '#ce501b',
      text: 'Debe seleccionar una plantilla',
      confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        }
    });
    return;
  }

  buscando.value = true;

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

     // ✅ Determinar el tipo de búsqueda según el tab activo
    let porTxt = '';
    let q1 = '';
    let q2 = '';
    let ptRb = '';
    let sOperador = '';
    let excluirTxt = null;
    
    switch (tabBusqueda.value) {
      case 'texto':
        porTxt = '|Texto';
        q1 = '|' + (textoBuscar.value || '');
        
        if (textoRadio.value === '2') {
          // Búsqueda aproximada
          ptRb = '|Aproximada';
          q2 = '|' + (textoBuscar2.value || '');
          sOperador = '|' + textoOperador.value;
          
          // Solo enviar excluirTxt si el checkbox está activo y hay texto
          if (excluirTextoActivo.value && textoExcluir.value) {
            excluirTxt = '|' + textoExcluir.value;
          }
        } else {
          // Búsqueda exacta en vacio
          ptRb = '|Exacta';
          q2 = '|';
          sOperador = '|Y';
        }
        break;
        
      case 'anotaciones':
        porTxt = '|Anotaciones';
        q1 = '|' + (anotacionesBuscar.value || '');
        
        if (anotacionesRadio.value === '2') {
          // Búsqueda aproximada
          ptRb = '|Aproximada';
          q2 = '|' + (anotacionesBuscar2.value || '');
          sOperador = '|' + anotacionesOperador.value;
        } else {
          // Búsqueda exacta en vacio
          ptRb = '|Exacta';
          q2 = '|';
          sOperador = '|Y';
        }
        break;
        
      case 'atributos':
        porTxt = '|Atributos';
        q1 = '|';
        q2 = '|';
        ptRb = '|1';
        sOperador = '|Y';
        break;
    }


    // ✅ Construir Valores en el formato esperado: { "NombreCampo": ["tipo", "valor"] }
    const valoresFormateados = {};
    
    camposBusqueda.value.forEach(campo => {
      const valor = valoresBusqueda.value[campo.nombre];
      if (valor !== undefined && valor !== null && valor !== '') {
        // Mapear tipo Vue a tipo esperado por backend
        let tipoBD = 'nvarchar';
        if (campo.tipo) {
          const tipoLower = campo.tipo.toLowerCase();
          if (tipoLower.includes('int')) tipoBD = 'int';
          else if (tipoLower.includes('date')) tipoBD = 'datetime';
          else tipoBD = 'nvarchar';
        }
        
        // Para fechas, el backend espera [tipo, fechaInicio, fechaFin]
        if (tipoBD === 'datetime') {
          valoresFormateados[campo.nombre] = [tipoBD, valor, valor];
        } else {
          valoresFormateados[campo.nombre] = [tipoBD, valor];
        }
      }
    });

     // ── Detectar si es búsqueda en carpeta o normal ──
    const esBusquedaCarpeta = tocId > 0;

   let response;

   if(esBusquedaCarpeta){

    //vamos a integrar el API para que mande la lista de archivos que contiene la carpeta y subcarpeta 
 
    const response2 = await axios.get(`/api/Busqueda/documentos-por-toc/${tocId}`);

  
     if (response2.data.success) {

     //onst listaTocIds = response2.data.data.map(doc => doc.tocId);      
 
     //El SP ya devuelve templateId, solo hay que incluirlo
      const listaTocIds = response2.data.data.map(doc => ({
          tocId:      doc.tocId,
          templateId: doc.templateId   // ← ya viene del SP
      }));

    //Guardar el tocId de la carpeta para usarlo después
     tocIdCarpetaActual.value = tocId

     const requestBody = {
        PlantillaId: '|' + plantillaSeleccionada.value,
        PorTxt: porTxt,
        PtRb: ptRb,
        Q1: q1,
        Q2: q2,
        SOperador: sOperador,
        ExcluirTxt: excluirTxt,
        Filename: '|' + (atributosBuscar.value || ''),
        FechaMod: '|' + (fechaAtributos.value || ''),
        //TocId: tocId,   // ← NUEVO: TocId de la carpeta
        TocId: listaTocIds, //vamos a mandarle una lista de tocId
        Valores: valoresFormateados
      };

      // ✅ Extraer templateIds únicos de los documentos encontrados
    const templateIdsUnicos = [...new Set(response2.data.data.map(doc => doc.templateId))]

    await cargarPlantillas()
    // ✅ Filtrar el selector de plantillas solo con las que aparecen en esta carpeta
    plantillas.value = plantillas.value.filter(p => templateIdsUnicos.includes(p.codigo))

    // para que el selector muestre el nombre correcto
    if (plantillas.value.length > 0) {
      // Si la plantilla actual ya está en la lista filtrada, mantenerla
      const existe = plantillas.value.find(p => p.codigo === plantillaSeleccionada.value)
      if (!existe) {
        plantillaSeleccionada.value = plantillas.value[0].codigo
      }
    }

try {
    //API para busqueda en carpeta 
     response = await axios.post(
      `/api/Busqueda/avanzada-Carpeta?idUsuarioSesion=${idUsuarioSesion}`,
      requestBody
    );


      if (response.data.success) {
      resultados.value = response.data.data.sort((a, b) => a.templateId - b.templateId);
      columnaAgrupada.value = null;
   
      if (resultados.value.length === 0) {
        Swal.fire({ icon: 'info', title: 'Sin resultados', text: 'No se encontraron expedientes' });
      } else {          
            Swal.fire({ 
          icon: 'success', 
          iconColor: '#ce501b', 
          title: 'Búsqueda completada', 
          confirmButtonColor: '#ce501b',  
          customClass: {
           title: 'swal-title-custom',
           confirmButton: 'swal-btn-confirmar',
           container: 'swal-sobre-modal',
          },
          text: `Se encontraron ${resultados.value.length} resultado(s)`, timer: 2000, showConfirmButton: false });

        }
    } else {
      Swal.fire({ 
        icon: 'warning',
        iconColor: '#ce501b', 
        title: 'Advertencia', 
        text: response.data.mensaje || 'No se encontraron resultados',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
       });
      resultados.value = [];
    }




} catch (errorPost) {
  
  // Error HTTP con detalle del backend
  const status  = errorPost.response?.status;
  const data    = errorPost.response?.data;
  const message = errorPost.message;

  console.error('=== STATUS ===', status);           // 400, 500, etc.
  console.error('=== DATA ===', JSON.stringify(data, null, 2));  // mensaje del backend
  console.error('=== MESSAGE ===', message);

  // ✅ También mostrarlo en pantalla para verlo sin F12
  Swal.fire({
    icon: 'error',
    title: `Error ${status || 'sin conexión'}`,
    html: `
      <div style="text-align:left; font-size:12px;">
        <b>Mensaje:</b> ${data?.mensaje || message}<br><br>
        <b>Body enviado:</b>
        <pre style="max-height:200px; overflow:auto; font-size:10px; background:#f5f5f5; padding:8px">
          ${JSON.stringify(requestBody, null, 2)}
        </pre>
      </div>
    `,
    width: '650px',
    confirmButtonColor: '#ce501b'
  });


}




  }


   } else {
     

    // Construir columna y valor_columna desde los campos dinámicos
  let columna = '';
  let valorColumna = '';

      for (const campo of camposBusqueda.value) {
        const val = valoresBusqueda.value[campo.nombre];  // ← asegúrate de tener "const val"
        if (val !== undefined && val !== null && val !== '') {
          columna = campo.nombre;
          valorColumna = val;  // sin comillas extra
          break;
        }
    }

     // ✅ Construir el request en el formato EXACTO que espera el backend
    const requestBody = {
      PlantillaId: '|' + plantillaSeleccionada.value,
      columna: columna,
      valor_columna: valorColumna,
      PorTxt: porTxt,
      PtRb: ptRb,
      Q1: q1,
      Q2: q2,
      SOperador: sOperador,
      ExcluirTxt: excluirTxt,
      Filename: '|' + (atributosBuscar.value || ''),
      FechaMod: '|' + (fechaAtributos.value || ''),
      Valores: valoresFormateados
    };

     response = await axios.post(
      `/api/Busqueda/avanzada?idUsuarioSesion=${idUsuarioSesion}`,
      requestBody
    );


       if (response.data.success) {
      resultados.value = response.data.data;
      columnaAgrupada.value = null;

        // ✅ Llenar sección "Texto" con NroPag y Texto del resultado
        
        datosTexto.value = response.data.data
          .filter(item => item.texto || item.nropag)
          .map(item => ({
            nroPag: item.nropag || '-',
            ocurrencias: 1,
            texto: item.texto ? (item.texto.length > 200 ? item.texto.substring(0, 200) + '...' : item.texto) : '-'
          }));

        datosAnotaciones.value = response.data.data
          .filter(item => item.itemanotacion || item.anotacion)
          .map(item => ({
            nroPag: item.itemanotacion || '-',
            Texto: item.anotacion || '-'
          }));

        datosDetalle.value = response.data.data
          .filter(item => item.nombre_campo || item.tipo)
          .map(item => ({
            Campo: item.nombre_campo || '-',
            Descripcion: item.tipo || '-'
          }));

        //console.log('[LOTE] Datos Texto:', datosTexto.value);  //Usarlo solo para ver los errores en el testeo de Software
        
        
      if (resultados.value.length === 0) {
        Swal.fire({ 
          icon: 'info', 
          iconColor: '#ce501b',
          title: 'Sin resultados', 
          text: 'No se encontraron expedientes',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal',
            confirmButton: 'swal-btn-confirmar',
            cancelButton: 'swal-btn-cancelar'
          }
        });
      } else {
      
          if (tabBusqueda.value === 'texto') {
          Swal.fire({
            toast: true, position: 'top-end',
            icon: 'success', iconColor: '#2e7d32',
            title: 'Búsqueda completada',
            text: `Se encontraron ${resultados.value.length} resultado(s)`,
            timer: 2500, showConfirmButton: false,
            customClass: { container: 'swal-sobre-modal' }
          });
             // ✅ NUEVO: cargar el detalle (Contenido de Texto resaltado) automáticamente
          await cargarDetalleExpediente(resultados.value[0]);
          
          // Apertura automática del primer documento desactivada
         // await visualizarDocumento(resultados.value[0]);
        } else {
          Swal.fire({
            icon: 'success', 
            iconColor: '#ce501b', 
            title: 'Búsqueda completada', 
            confirmButtonColor: '#ce501b', 
            text: `Se encontraron ${resultados.value.length} resultado(s)`, 
            customClass: {
              title: 'swal-title-custom'
            }, timer: 2000, showConfirmButton: false
           });
        }

      }
    } else {
      Swal.fire({ 
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Advertencia',
        text: response.data.mensaje || 'No se encontraron resultados',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      });
      resultados.value = [];
    }


   

  }
    //console.log('Response:', response.data);  //Usarlo solo para ver los errores en el testeo de Software
    
  } catch (error) {
    //console.error('Error al buscar:', error);   //Usarlo solo para ver los errores en el testeo de Software
    //console.error('Detalle:', error.response?.data);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al realizar la búsqueda',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
    resultados.value = [];
  } finally {
    buscando.value = false;
  }
};


const limpiar = () => {

  tocIdCarpetaActual.value = 0  //resetear al limpiar la busqueda de carpeta

  plantillaSeleccionada.value = null;
  camposBusqueda.value = [];
  valoresBusqueda.value = {};
  
  // Limpiar campos de texto
  textoBuscar.value = '';
  textoBuscar2.value = '';
  textoOperador.value = 'Y';
  textoRadio.value = '1';
  excluirTextoActivo.value = false;
  textoExcluir.value = '';
  
  // Limpiar campos de anotaciones
  anotacionesBuscar.value = '';
  anotacionesBuscar2.value = '';
  anotacionesOperador.value = 'Y';
  anotacionesRadio.value = '1';
  
  // Limpiar campos de atributos
  atributosBuscar.value = '';
  fechaAtributos.value = '';
  
  // Limpiar resultados
  resultados.value = [];
  datosTexto.value = [];
  datosAnotaciones.value = [];
  datosDetalle.value = [];
  expedienteSeleccionado.value = null;
  
  // Resetear tabs
  tabBusqueda.value = 'texto';
  tabResultados.value = 'texto';
  
  // Resetear agrupamiento
  columnaAgrupada.value = null;
  columnaSeleccionadaTemp.value = null;
  busquedaColumna.value = '';
  //itemsPorPagina.value = 10;
  agrupamientoPorGrupo.value = {} 

  headersExpedientes.value = [
    { title: '', key: 'checkbox', sortable: false, width: '50px' }
  ];
};


// ✅ Función para detectar y formatear fechas
const formatearValorCelda = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '-';
  
  // Detectar si es una fecha ISO (contiene 'T' o tiene formato datetime)
  if (typeof valor === 'string') {
    // Patrón: "2026-01-13T00:00:00" o "2026-01-13 00:00:00"
    const patronFechaISO = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}/;
    
    if (patronFechaISO.test(valor)) {
      // Extraer solo la fecha (YYYY-MM-DD)
      return valor.split('T')[0].split(' ')[0];
    }
  }
  
  return valor;
};


const procesarEstructura = (data, plantillaId) => {
  if (plantillaId > 0) {
    plantillaSeleccionada.value = plantillaId;
  }

  camposBusqueda.value = data.map(campo => ({
    nombre: campo.column_name,
    tipo: campo.data_type,
    valores: campo.valores
  }));

  headersExpedientes.value = [
    { title: '', key: 'checkbox', sortable: false, width: '50px' },
    ...camposBusqueda.value.map(campo => ({
      title: campo.nombre,
      key: campo.nombre.toLowerCase(),
      sortable: true
    })),
    { title: 'DOCUMENTO', key: 'documento', sortable: true }
  ];

  valoresBusqueda.value = {};
  camposBusqueda.value.forEach(campo => {
    valoresBusqueda.value[campo.nombre] = '';
  });
};



// ============================================================
// FUNCIONES PARA VISOR DE DOCUMENTO
// ============================================================

const visualizarDocumento = async (item) => {

  zoomLevel.value = 1; // ✅ Reiniciar zoom al abrir nuevo documento
  escalaInicial.value = 1; // ✅ Reiniciar escala

  const tocId = item.tocid;
  
  const templateId = item.templateid ?? item.templateId ?? plantillaSeleccionada.value

  if (!tocId || !templateId) {
    Swal.fire({ icon: 'warning', title: 'Sin datos', text: 'No se pudo determinar el documento' });
    return;
  }

  documentoContexto.value = item;
  cargandoEstructuraVisor.value = true;
  cargandoVisor.value = true;
  errorVisor.value = '';
  urlVisor.value = '';
  archivoNoVisualizable.value = false;
  anotaciones.value = [];
  modoAnotacion.value = false;
  nuevaAnotacionVisible.value = false;
  dialogVisor.value = true;
  modoPaginasMultiplesVisor.value = false
  listaPaginasVisor.value = []
  urlPaginaMultipleVisor.value = ''
  paginaMultipleActualVisor.value = 1

  // ── AGREGAR estas 4 líneas ──
  esVideoVisor.value = false
  esAudioVisor.value = false  // ✅ verificar que esté
  segmentosVideo.value = []
  segmentoActualVisor.value = -1
  cargandoBusquedaVideo.value = false


  try {
    // Cargar estructura, documento y anotaciones en paralelo
    const [responseEstructura] = await Promise.all([
      axios.get(`/api/Plantillas/estructura/${templateId}`),
      cargarDocumentoVisor(tocId, templateId)
    ]);
    await cargarAnotacionesVisor(tocId);

    cargandoEstructuraVisor.value = false;

    if (responseEstructura.data.success && responseEstructura.data.data.length > 0) {
      estructuraVisor.value = responseEstructura.data.data;

      // Inicializar valores vacíos
      valoresVisor.value = {};
      estructuraVisor.value.forEach(campo => {
        valoresVisor.value[campo.column_name] = '';
      });

      // Cargar valores existentes
      await cargarValoresVisor(tocId, templateId);
    }

  } catch (error) {
    cargandoEstructuraVisor.value = false;
    cargandoVisor.value = false;
    //console.error('Error al visualizar documento:', error);  //Usarlo solo para ver los errores en el testeo de Software
  }
};


const obtenerTextoBusquedaParaResaltar = () => {
  if (tabBusqueda.value !== 'texto') return ''

  const t1 = (textoBuscar.value || '').trim()
  if (!t1) return ''

  if (textoRadio.value === '2') {
    const t2 = (textoBuscar2.value || '').trim()
    return t2 ? `${t1} ${t2}` : t1
  }

  return t1

}


// ✅ NUEVO: Términos individuales a resaltar (separados de la función del visor)
const terminosResaltar = computed(() => {
  if (tabBusqueda.value !== 'texto') return [];

  const terms = [];
  const t1 = (textoBuscar.value || '').trim();
  if (t1) terms.push(t1);

  if (textoRadio.value === '2') {
    const t2 = (textoBuscar2.value || '').trim();
    if (t2) terms.push(t2);
  }

  return terms;
});

// Escapar caracteres especiales de regex
const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Escapar HTML para que el texto original no rompa el render ni permita inyección
const escapeHtml = (str) => str
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

// ✅ NUEVO: Envuelve las coincidencias en <mark> para resaltarlas en "Contenido de Texto"
const resaltarCoincidencias = (texto) => {
  if (!texto) return '';

  const textoEscapado = escapeHtml(texto);
  const terminos = terminosResaltar.value;

  if (!terminos.length) return textoEscapado;

  const patron = terminos.map(t => escapeRegExp(t)).join('|');
  const regex = new RegExp(`(${patron})`, 'gi');

  return textoEscapado.replace(regex, '<mark class="resaltado-busqueda">$1</mark>');
};


const cargarDocumentoVisor = async (tocId, plantillaId) => {
  try {
    const token = localStorage.getItem('token')
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const nombreArchivo = documentoContexto.value?.documento || ''
    const extDoc = nombreArchivo.split('.').pop().toLowerCase()

    if (extDoc === 'doc' || extDoc === 'docx') {
      cargandoVisor.value = false
      errorVisor.value = ''
      urlVisor.value = ''
      modoPaginasMultiplesVisor.value = false
      esImagenVisor.value = false
      esVideoVisor.value = false
      esAudioVisor.value = false
      archivoNoVisualizable.value = true
      return
    }
 
    // ══════════════════════════════════════════════
    // 1. ZIP / RAR → sin visor
    // ══════════════════════════════════════════════
    if (extDoc === 'zip' || extDoc === 'rar') {
      cargandoVisor.value = false
      errorVisor.value = 'El visor no está disponible para archivos ZIP o RAR'
      return
    }
 
    // ══════════════════════════════════════════════
    // 2. VIDEO → STREAMING PROGRESIVO (NO blob)
    // ══════════════════════════════════════════════
    const extensionesVideo = ['mp4', 'mkv', 'webm', 'mov', 'avi', 'm4v']
 
    if (extensionesVideo.includes(extDoc)) {
      esVideoVisor.value = true
 
      if (urlVisor.value && urlVisor.value.startsWith('blob:')) {
        URL.revokeObjectURL(urlVisor.value)
      }
 
      // ✅ URL directa con token → el <video> hace Range Requests
      urlVisor.value =  buildApiUrl(
      `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
       )
      cargandoVisor.value = false
 
      // Buscar segmentos de texto en el video (no bloquea la reproducción)
      await buscarEnVideo(plantillaId)
      return   // ← MUY IMPORTANTE: salir aquí
    }
 
    // ══════════════════════════════════════════════
    // 3. AUDIO → STREAMING PROGRESIVO (NO blob)
    // ══════════════════════════════════════════════
    const extensionesAudio = ['mp3', 'wav', 'flac', 'm4a']
 
    if (extensionesAudio.includes(extDoc)) {
      esAudioVisor.value = true
 
      if (urlVisor.value && urlVisor.value.startsWith('blob:')) {
        URL.revokeObjectURL(urlVisor.value)
      }
 
      // ✅ URL directa con token
      urlVisor.value = buildApiUrl(
       `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
        )
      cargandoVisor.value = false
 
      await buscarEnVideo(plantillaId)
      return   // ← salir aquí
    }
 
    // ══════════════════════════════════════════════
    // 4. CONSULTAR PÁGINAS (solo PDF/imagen)
    // ══════════════════════════════════════════════
    let totalPags = 0
    let paginas = []
 
    try {
      const resPaginas = await axios.get(
        `/api/Indexacion/paginas/${tocId}/${plantillaId}?idUsuarioSesion=${idUsuarioSesion}&nroDocumento=${encodeURIComponent(nombreArchivo)}`
      )
      if (resPaginas.data.success) {
        totalPags = resPaginas.data.totalPaginas
        paginas = resPaginas.data.data
      }
    } catch (e) {
      totalPags = 0
    }
 
    // ══════════════════════════════════════════════
    // 5. MODO MULTI-PÁGINA (imágenes paginadas)
    // ══════════════════════════════════════════════
    if (totalPags > 1) {
      const tienePdfs = paginas.some(p => p.path.toLowerCase().endsWith('.pdf'))
 
      if (tienePdfs) {
        errorVisor.value = 'No es posible visualizar múltiples documentos PDF.'
        cargandoVisor.value = false
        return
      }
 
      modoPaginasMultiplesVisor.value = true
      listaPaginasVisor.value = paginas
      paginaMultipleActualVisor.value = 1
      urlPaginaMultipleVisor.value = ''
 
      await cargarPaginaMultipleVisor(1)
      cargandoVisor.value = false
      return
    }
 
    // ══════════════════════════════════════════════
    // 6. PDF / IMAGEN / TIFF → flujo original con blob
    // ══════════════════════════════════════════════
    modoPaginasMultiplesVisor.value = false
    listaPaginasVisor.value = []
 
    const response = await axios.get(
      `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}`,
      { responseType: 'arraybuffer' }
    )
 
    const contentType = response.headers['content-type'] || 'application/pdf'
    const esTiff = contentType === 'image/tiff' || contentType === 'image/tif'
 
    if (urlVisor.value) URL.revokeObjectURL(urlVisor.value)
 
    if (esTiff) {
      const ifds = UTIF.decode(response.data)
      UTIF.decodeImage(response.data, ifds[0])
      const rgba = UTIF.toRGBA8(ifds[0])
      const w = ifds[0].width
      const h = ifds[0].height
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(w, h)
      imageData.data.set(new Uint8Array(rgba))
      ctx.putImageData(imageData, 0, 0)
      urlVisor.value = canvas.toDataURL('image/png')
      esImagenVisor.value = true
    } else {
      esImagenVisor.value = contentType.startsWith('image/')
      const blob = new Blob([response.data], { type: contentType })
      const blobUrl = URL.createObjectURL(blob)
 
      if (esImagenVisor.value) {
        urlVisor.value = blobUrl
      } else {
        const textoBuscado = obtenerTextoBusquedaParaResaltar()
        if (textoBuscado) {
          const esFrase = tabBusqueda.value === 'texto' && textoRadio.value === '1'
          urlVisor.value = `/pdfjs/web/viewer.html?file=${encodeURIComponent(blobUrl)}#search=${encodeURIComponent(textoBuscado)}&phrase=${esFrase}&highlightAll=true`
        } else {
          urlVisor.value = blobUrl
        }
      }
    }
 
  } catch (error) {
    errorVisor.value = error.response?.status === 404
      ? 'Archivo no encontrado en el servidor'
      : 'No se pudo cargar el documento'
  } finally {
    cargandoVisor.value = false
  }
}

const descargarDocumentoWord = () => {
  const item = documentoContexto.value
  if (!item) return

  const idUsuarioSesion = localStorage.getItem('idUsuario')
  const plantillaId = item.templateid ?? item.templateId ?? plantillaSeleccionada.value

  procesarDescargaArchivo({
    url: `/api/Indexacion/ver-documento/${item.tocid}/${idUsuarioSesion}/${plantillaId}`,
    nombre: item.documento
  })
}





const cargarValoresVisor = async (tocId, templateId) => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const response = await axios.get(
      `/api/Indexacion/obtener/${tocId}/${templateId}?idUsuarioSesion=${idUsuarioSesion}`
    );

    if (response.data.success && response.data.data) {
      const datosExistentes = response.data.data;
      for (const campo of estructuraVisor.value) {
        if (datosExistentes[campo.column_name] !== undefined && datosExistentes[campo.column_name] !== null) {
          let valor = datosExistentes[campo.column_name];

          // Convertir fecha "2026-02-25T00:00:00" → "2026-02-25"
          if (esCampoFecha(campo.data_type) && valor) {
            const fecha = new Date(valor);
            if (!isNaN(fecha.getTime())) {
              const year = fecha.getFullYear();
              const month = String(fecha.getMonth() + 1).padStart(2, '0');
              const day = String(fecha.getDate()).padStart(2, '0');
              valor = `${year}-${month}-${day}`;
            }
          }

          valoresVisor.value[campo.column_name] = valor;
        }
      }
    }
  } catch (error) {
    //console.log('No hay indexación previa para este documento');  //Usarlo solo para ver los errores en el testeo de Software
  }
};

// ============================================================
// FUNCIONES PARA ANOTACIONES
// ============================================================

const cargarAnotacionesVisor = async (tocId) => {
  try {
    const response = await axios.get(
      `/api/Indexacion/obtener-anotaciones/${tocId}`
    );
    if (response.data.success) {
      anotaciones.value = response.data.data;
    }
  } catch (error) {
    //console.error('Error al cargar anotaciones:', error);   //Usarlo solo para ver los errores en el testeo de Software
  }
};

const agregarAnotacion = (event) => {
  if (!modoAnotacion.value || nuevaAnotacionVisible.value) return;
  event.stopPropagation();

  const visorDiv = event.currentTarget;
  const rect = visorDiv.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;

  nuevaAnotacionX.value = parseFloat(x.toFixed(2));
  nuevaAnotacionY.value = parseFloat(y.toFixed(2));
  nuevaAnotacionTexto.value = '';
  nuevaAnotacionVisible.value = true;
  editandoAnotacionIndex.value = null;

  setTimeout(() => {
    document.getElementById('sticky-note-input-busqueda')?.focus();
  }, 100);
};

const confirmarAnotacion = () => {
  if (!nuevaAnotacionTexto.value.trim()) {
    cancelarAnotacion();
    return;
  }

  if (editandoAnotacionIndex.value !== null) {
    anotaciones.value[editandoAnotacionIndex.value].texto = nuevaAnotacionTexto.value.trim();
  } else {
    anotaciones.value.push({
      tocId: documentoContexto.value.tocid,
      texto: nuevaAnotacionTexto.value.trim(),
      x: nuevaAnotacionX.value,
      y: nuevaAnotacionY.value
    });
  }
  cancelarAnotacion();
};

const cancelarAnotacion = () => {
  nuevaAnotacionVisible.value = false;
  nuevaAnotacionTexto.value = '';
  editandoAnotacionIndex.value = null;
};

const editarAnotacion = (index) => {
  const anot = anotaciones.value[index];
  nuevaAnotacionX.value = anot.x;
  nuevaAnotacionY.value = anot.y;
  nuevaAnotacionTexto.value = anot.texto;
  editandoAnotacionIndex.value = index;
  nuevaAnotacionVisible.value = true;

  setTimeout(() => {
    document.getElementById('sticky-note-input-busqueda')?.focus();
  }, 100);
};

const eliminarAnotacion = (index) => {
  anotaciones.value.splice(index, 1);
};

const guardarAnotaciones = async () => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    const response = await axios.post(
      `/api/Indexacion/guardar-anotaciones?idUsuarioSesion=${idUsuarioSesion}`,
      {
        tocId: documentoContexto.value.tocid,
        plantillaId: plantillaSeleccionada.value,
        anotaciones: anotaciones.value
      }
    );

    if (response.data.success) {
      modoAnotacion.value = false;
      Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Guardado!',
        text: response.data.mensaje,
        timer: 2000,
        showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }
  } catch (error) {
    //console.error('Error al guardar anotaciones:', error);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudieron guardar las anotaciones',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  }
};


const imprimirDocumento = () => {
  if (!urlVisor.value) return;

  if (esImagenVisor.value) {
    // Para imágenes (incluye TIFF convertido a PNG)
    const ventana = window.open('', '_blank');
    if (ventana) {
      ventana.document.write(`
        <html>
          <head><title>Imprimir</title></head>
          <body style="margin:0; display:flex; justify-content:center; align-items:center;">
            <img src="${urlVisor.value}" style="max-width:100%; max-height:100vh;" onload="window.print(); window.close();" />
          </body>
        </html>
      `);
      ventana.document.close();
    }
  } else {
    // Para PDFs (iframe con pdfjs o blob URL)
    const ventana = window.open(urlVisor.value, '_blank');
    if (ventana) {
      ventana.onload = () => {
        setTimeout(() => ventana.print(), 500);
      };
    }
  }
};



const resultadosPorGrupo = computed(() => {
  if (!resultados.value.length) return []

  const grupos = {}
  for (const item of resultados.value) {
    const tid = item.templateid ?? item.templateId ?? 0
    if (!grupos[tid]) grupos[tid] = []
    grupos[tid].push(item)
  }

  return Object.entries(grupos).map(([templateId, items]) => {
    initGrupo(templateId)  // ✅ Asegurar que el estado existe
    const primeraFila = items[0]
    const excluir = ['version', 'idtipoper', 'templateid']

    const headers = [
      { title: '', key: 'checkbox', sortable: false, width: '50px' },
      ...Object.keys(primeraFila)
        .filter(k => !excluir.includes(k.toLowerCase()) && k.toLowerCase() !== 'tocid')
        .map(k => ({ title: k.toUpperCase(), key: k.toLowerCase(), sortable: true }))
    ]

    return { templateId, items, headers }
  })
})


const cargarPaginaMultipleVisor = async (nroPag) => {

  zoomLevel.value = 1; // ✅ Reiniciar zoom al cambiar de página
  escalaInicial.value = 1; // ✅ Reiniciar escala

  if (!listaPaginasVisor.value.length) return

  // ✅ Solo validar por rango — sin find, sin depender del nombre de la propiedad
  if (nroPag < 1 || nroPag > listaPaginasVisor.value.length) return

  cargandoPaginaMultipleVisor.value = true
  esImagenPaginaMultipleVisor.value = false
  errorPaginaMultipleVisor.value = ''

  if (urlPaginaMultipleVisor.value?.startsWith('blob:')) {
    URL.revokeObjectURL(urlPaginaMultipleVisor.value)
  }
  urlPaginaMultipleVisor.value = ''

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const templateId = documentoContexto.value?.templateid
                    ?? documentoContexto.value?.templateId
                    ?? plantillaSeleccionada.value
    const tocId = documentoContexto.value?.tocid

    const response = await axios.get(
      `/api/Indexacion/ver-pagina/${tocId}/${templateId}/${nroPag}?idUsuarioSesion=${idUsuarioSesion}`,
      { responseType: 'arraybuffer' }
    )

    const contentType = response.headers['content-type'] || 'image/tiff'
    const esTiff = contentType === 'image/tiff' || contentType === 'image/tif'

    if (esTiff) {
      const ifds = UTIF.decode(response.data)
      UTIF.decodeImage(response.data, ifds[0])
      const rgba = UTIF.toRGBA8(ifds[0])
      const w = ifds[0].width
      const h = ifds[0].height
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(w, h)
      imageData.data.set(new Uint8Array(rgba))
      ctx.putImageData(imageData, 0, 0)
      urlPaginaMultipleVisor.value = canvas.toDataURL('image/png')
      esImagenPaginaMultipleVisor.value = true
    } else {
      esImagenPaginaMultipleVisor.value = contentType.startsWith('image/')
      const blob = new Blob([response.data], { type: contentType })
      urlPaginaMultipleVisor.value = URL.createObjectURL(blob)
    }

    paginaMultipleActualVisor.value = nroPag

  } catch (error) {
    const status = error.response?.status
    errorPaginaMultipleVisor.value = status === 404
      ? `Página ${nroPag} no encontrada`
      : `Error al cargar página ${nroPag} (${status || 'sin conexión'})`
  } finally {
    cargandoPaginaMultipleVisor.value = false
  }
}








</script>

<style scoped>
/* ✅ Estilos para la tabla manual de agrupamiento */
.tabla-agrupada {
  width: 100%;
  border-collapse: collapse;
}

.tabla-agrupada thead {
  background-color: #f5f5f5;
}

.tabla-agrupada th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.tabla-agrupada td {
  padding: 12px 16px;
  font-size: 0.875rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.tabla-agrupada tbody tr:hover {
  background-color: #f5f5f5;
}

/* Estilos para filas de grupo */
.grupo-fila {
  background-color: #e3f2fd !important;
  cursor: pointer;
}

.grupo-fila:hover {
  background-color: #bbdefb !important;
}

.item-fila {
  background-color: #fafafa;
}

.item-fila:hover {
  background-color: #f0f0f0 !important;
}
</style>

<style>
  
.dialog-indexacion .v-overlay__content {
  max-height: 97vh !important;
  height: 97vh !important;
  max-width: 1400px !important;
  width: 97vw !important;
  margin: 0 !important;
}

.dialog-indexacion .v-overlay__content .v-card {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}

.swal-sobre-modal {
  z-index: 3000 !important;
}

/* ===== STICKY NOTES ===== */
.sticky-note {
  position: absolute;
  z-index: 10;
  width: 200px;
  background: #fff9c4;
  border: 1px solid #f0e68c;
  border-radius: 2px;
  box-shadow: 2px 2px 8px rgba(0,0,0,0.3);
  font-family: 'Segoe UI', sans-serif;
  pointer-events: auto;
}

.sticky-note-editing {
  width: 220px;
  z-index: 20;
  box-shadow: 3px 3px 12px rgba(0,0,0,0.4);
}

.sticky-note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px;
  border-bottom: 1px solid #f0e68c;
  min-height: 24px;
}

.sticky-note-number {
  font-size: 10px;
  font-weight: 600;
  color: #b8860b;
}

.sticky-note-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.sticky-note-btn {
  cursor: pointer;
  color: #999 !important;
  transition: color 0.2s;
}

.sticky-note-btn:hover {
  color: #333 !important;
}

.sticky-note-btn-delete:hover {
  color: #d32f2f !important;
}

.sticky-note-body {
  padding: 6px 8px;
  font-size: 12px;
  color: #333;
  word-wrap: break-word;
  max-height: 120px;
  overflow-y: auto;
  line-height: 1.4;
}

.sticky-note-textarea {
  width: 100%;
  border: none;
  background: transparent;
  padding: 6px 8px;
  font-size: 12px;
  color: #333;
  resize: none;
  outline: none;
  font-family: 'Segoe UI', sans-serif;
  line-height: 1.4;
}

.sticky-note-textarea::placeholder {
  color: #bbb;
}

.sticky-note-footer {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding: 4px 6px;
  border-top: 1px solid #f0e68c;
}

.sticky-btn {
  padding: 2px 10px;
  font-size: 11px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 500;
}

.sticky-btn-cancel {
  background: transparent;
  color: #999;
}

.sticky-btn-cancel:hover {
  color: #333;
}

.sticky-btn-save {
  background: #f9a825;
  color: white;
}

.sticky-btn-save:hover {
  background: #f57f17;
}

</style>

<style> 

 .fila-seleccionada {
  background-color: #e3f2fd !important;
  outline: 2px solid #1976d2;
}

.fila-seleccionada:hover {
  background-color: #bbdefb !important;
}

</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

.mi-tabla thead tr th {
  background-color: #def2ff !important;
  color: #37495f !important;
  font-weight: bold !important;
}

.resaltado-busqueda {
  background-color: #ffeb3b;
  color: #000;
  font-weight: 600;
  padding: 0 2px;
  border-radius: 2px;
}


</style>

